module.exports = __webpack_public_path__ + "img/album-cover-placeholder.12db4330.jpg";